export default ({
    name : 'Content'
    , data () {
        return {
            noticeUrl : '/notice'
            , noticeSubQuery : '?not_id='
        }
    }
    , created () {
        this.code = 'product_basic';
        this.basic = this.getDetailDataByCode(this.code);
        this.notice = this.getDetailDataByCode('notice');
        return {}
    }
    , mounted () {
		this.publisher();
        this.$nextTick(function () {
            this.controlContentBorder();
        });
    }
    , computed : {
        useCategoryStyle () {
        }
        , displayNotice() {
            return this.isSetNotice() ? this.notice.displayNotice : false;
        }
        , isNotice() {
            return this.isSetContentsNotice() ? this.notice.isNotice : false;
        }
        , noticeType() {
            return this.setNoticeType();
        }
        , noticeTitle() {
            return this.isSetContentsNotice() ? this.notice.data.not_title : '등록된 공지사항이 없습니다.';
        }
        , noticeLink() {
            return (this.notice.displayNotice && this.notice.isNotice) ? this.noticeUrl + this.noticeSubQuery + this.notice.data.not_id : 'javascript:;';
        } 
        , noticeListLink() {
            return (this.notice.displayNotice && this.notice.isNotice) ? this.noticeUrl : 'javascript:;';
        }
    }
    , methods : {
        isUseCategory () { // 카테고리 사용 미사용으로 인한 UI 변경 필요한경우.
            let hamburgerMenuData = this.getDetailDataByCode('hamburger_menu')
            if (hamburgerMenuData.use == 'N') { return false; }
            if (typeof hamburgerMenuData.data.category_use == 'undefined' || hamburgerMenuData.data.category_use.value == 'N') { return false; }
            return true;
        }
        , setContainerHeight () {
            let header    = document.querySelector('#header')
            let container = document.querySelector('#container')
            if (header === null && container === null) {
                return
            }
            container.style.marginTop = header.offsetHeight+'px';
        }  
        , isSetNotice () {
            return ((typeof this.notice != 'undefined') && this.notice.displayNotice)
        }
        , isSetContentsNotice () {
            return (this.isSetNotice() && this.notice.isNotice)
        }
        , setNoticeType() {
            let type = '';
            if (this.isSetContentsNotice()) {
                switch (this.notice.data.not_type) {
                    case 'EVENT':
                        type = '[이벤트]';
                        break;
                    case 'PRODUCT':
                        type = '[상품]';
                        break;
                    case 'NOTICE': 
                        type = '[공지사항]';
                        break;
                }
            }
            return type;
        }
		, publisher () {
		}
    }
    , updated () {
        if (this.getAdminEditMode()) {
            this.setContainerHeight()
        }
    }
})
